import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'
import "bootstrap/dist/css/bootstrap.min.css"
import './index.css';
import "bootstrap/dist/js/bootstrap.bundle.js"
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'animate.css'
import "wowjs/css/libs/animate.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Suspense fallback="loading">
    <App />
    </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
